function Icon2() {
  return (
    <svg
      id="icon2__Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 86"
    >
      <defs>
        <style>{'.icon2__cls-2{fill:#0d1f43}'}</style>
      </defs>
      <circle cx="50" cy="42.88" r="42.5" fill="#fad0dd" />
      <path
        className="icon2__cls-1"
        d="M49.3 49c8.91 0 18-10.51 18-20.82a18 18 0 1 0-35.95 0C31.33 38.45 40.4 49 49.3 49zm0-36.8a16 16 0 0 1 16 16c0 9.15-8.21 18.82-16 18.82s-16-9.67-16-18.82a16 16 0 0 1 16-16.04zM68.29 53.74a86.82 86.82 0 0 0-18.66-2.57 86.47 86.47 0 0 0-18.7 2.47c-8.74 2-15.08 11.56-15.08 22.74v8.24a1 1 0 1 0 2 0v-8.24c0-10.25 5.69-19 13.53-20.78a83.71 83.71 0 0 1 18.25-2.43 85.42 85.42 0 0 1 18.22 2.52c6.31 1.44 11.43 7.53 13 15.5a1 1 0 1 0 2-.39c-1.76-8.75-7.48-15.44-14.56-17.06z"
      />
      <path
        className="icon2__cls-1"
        d="M67.06 71.42H57a3.17 3.17 0 1 1 0-6.33h10.06a3.17 3.17 0 0 1 0 6.33zM57 67.09a1.17 1.17 0 1 0 0 2.33h10.06a1.17 1.17 0 0 0 0-2.33z"
      />
    </svg>
  );
}

export default Icon2;
